import { Class } from '@vote4dance/judging-schema';
import { ClassId, CompetitionId } from '@vote4dance/judging-types';
import { StreamSource } from "../hooks/streams";

export type ClassItem = Class & {
    class_count: string,
    round_count: string,
    class_count_registration: string,
    class_group_count: number,
    class_role_count: number,
    panel_locked: number,
    floor_names: string | null
}

type ClassItemCompanion = {
    getClassLabel(classItem: ClassItem): string;
}

export const ClassItem: ClassItemCompanion = {
    getClassLabel(classItem: ClassItem): string {
        return classItem.class_label ? classItem.class_label : (classItem.class_name || "")
    }
}

export function ClassesSource(competition_id: CompetitionId) {
    return new StreamSource<ClassItem[]>(`/classes/${competition_id}`);
}

export function ClassItemSource(competition_id: CompetitionId, class_id: ClassId) {
    return new StreamSource<ClassItem>(`/classes/${competition_id}/${class_id}`);    
}
